module.exports = __webpack_public_path__ + "img/team.9f49f87e.svg";